import { useState, useContext, useEffect, useActionState } from "react";
import axios from "axios";
import CookieContext from "../contexts/CookieContext";
import AppContext from "../contexts/AppContext";
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Guest from './Guest'

const StyledButton = styled.button`
  width: 200px;
  color: ${'lightgray'};
  background: ${({ disabled }) => disabled ? 'linear-gradient(180deg, #666666, #999999)' : 'linear-gradient(180deg, #100c08, #32dae6)'};
  ${({ disabled }) => disabled && `text-shadow: #cccccc 5px 5px 10px; box-shadow: #cccccc 5px 5px 10px;`};
`;

const WorkButton = styled.button`
  width: 200px;
  color: ${'lightgray'};
  background: ${({ disabled }) => disabled ? 'linear-gradient(180deg, #666666, #999999)' : 'linear-gradient(180deg, #100c08, #f59f3e)'};
  ${({ disabled }) => disabled && `text-shadow: #cccccc 5px 5px 10px; box-shadow: #cccccc 5px 5px 10px;`};
`;

const TimeTrackerButton = styled.button`
  width: 200px;
  color: ${'lightgray'};
  background: ${({ disabled }) => disabled ? 'linear-gradient(180deg, #666666, #999999)' : 'linear-gradient(180deg, #100c08, #b349ad)'};
  ${({ disabled }) => disabled && `text-shadow: #cccccc 5px 5px 10px; box-shadow: #cccccc 5px 5px 10px;`};
`;

const Home = () => {
  return (
    <>
      <div>ホーム画面</div>
    </>
  )
}
export default Home